import React from "react";
import { Authorize } from "../../components/authorize";
import * as customerSupplierService from "../../services/customer-supplier/customer-supplier-services";
import utility from "../../components/modal";
import * as Loader from "../../common/common";
import { messages } from "../../common/messages";
import DropDown from "../../components/form-controls/dropdown";
import { defaultListItem } from "../../common/const";
let filterDepts = [];
export default class CustomerSupplier extends Authorize {
  constructor(props) {
    super(props);
    this.state = {
      changeForm: {
        userName: "",
        userEmail: "",
        drpDwnChangeTo: "",
        drpdwnDepartments: "",
        departments: [],
        userType: "",
        isDropDown: true,
        users: [],
        userId: "",
        filteredDepartments: [],
      },
      validationMessages: {
        userNameVaidateMessage: "",
        userTypeValidateMessage: "",
        departmentValidateMessage: "",
        changeToValidateMessage: "",
      },
      isNoRecordsFound: false,
      isError: false,
      message: "",
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onClickLi = this.onClickLi.bind(this);
    this.onkeyPress = this.onkeyPress.bind(this);
    this.populateDepartments = this.populateDepartments.bind(this);
  }

  async onSubmit(e) {
    Loader.showLoader();
    e.preventDefault();

    this.setState({
      ...this.state,
      isError: false,
    });
    let { userName, drpDwnChangeTo, drpdwnDepartments } = this.state.changeForm;
    let validationErrors = Object.assign({}, this.state.validationMessages);
    let prevUserType = this.state.changeForm.userType;
    let isValidated = false;
    if (drpDwnChangeTo === "" || drpDwnChangeTo === undefined) {
      validationErrors.changeToValidateMessage =
        "Please select the client type.";
      isValidated = true;
    } else {
      validationErrors.changeToValidateMessage = "";
      if (prevUserType !== undefined) {
        if (
          prevUserType.toLowerCase() ===
          this.state.changeForm.drpDwnChangeTo.toLowerCase()
        ) {
          validationErrors.changeToValidateMessage =
            "Please select different Client Type.";
          isValidated = true;
        } else {
          validationErrors.changeToValidateMessage = "";
        }
      }
    }

    if (userName === "" || userName === undefined) {
      validationErrors.userNameVaidateMessage = "Please enter the Client Name.";
      isValidated = true;
    } else {
      validationErrors.userNameVaidateMessage = "";
    }

    if (drpdwnDepartments === "" || drpdwnDepartments === undefined) {
      validationErrors.departmentValidateMessage =
        "Please select the Department.";
      isValidated = true;
    } else {
      validationErrors.departmentValidateMessage = "";
    }

    if (!isValidated) {
      var that = this;
      var config = {
        message: messages.confirmChangeClient,
        onYesClick: async function () {
          let formData = (({userName, userEmail, drpDwnChangeTo, drpdwnDepartments, userType, userId}) => ({userName, userEmail, drpDwnChangeTo, drpdwnDepartments, userType, userId}))(that.state.changeForm)
          let { response, err } = await customerSupplierService.saveData(
            formData
          );
          Loader.hideLoader();

          if (err) {
            that.setState({
              ...that.state,
              loading: false,
            });
          } else if (response && response.err) {
            that.setState({
              ...that.state,
              loading: false,
            });
          } else {
            let respData = response.data;
            if (respData.success == true) {
              document.getElementById("lblUserType").innerText = "";
              that.setState({
                ...that.state,
                message: messages.changeClientTypeSuccessMessage,
                loading: false,
                changeForm: {
                  userName: "",
                  userEmail: "",
                  drpDwnChangeTo: "",
                  drpdwnDepartments: "",
                  departments: [],
                  userType: "",
                  isDropDown: true,
                  users: [],
                  userId: "",
                  filteredDepartments: [],
                },
              });
            } else {
              that.setState({
                ...that.state,
                message: response.data.message,
                isError: true,
                loading: false,
              });
            }
          }
        },
        onNoClick: null,
      };
      utility.showConfirm(config);
    }
    Loader.hideLoader();
    this.setState({
      validationMessages: validationErrors,
    });
  }
  onChange(e) {
    let value = e.target.value;
    let name = e.target.name;
    let prevUserType = this.state.changeForm.userType;
    let userType;
    let validationErrors = Object.assign({}, this.state.validationMessages);

    if (name === "drpDwnChangeTo") {
      if (value === "") {
        validationErrors.changeToValidateMessage =
          "Please select the Client Type.";
        document.getElementById("lstUsers").style.display = "none";
      } else {
        validationErrors.changeToValidateMessage = "";
        if (value === "Supplier" || value === "CustomerSupplier") {
        }
        if (prevUserType !== undefined) {
          if (prevUserType === value) {
            validationErrors.changeToValidateMessage =
              "Please select different Client Type.";
          } else {
            validationErrors.changeToValidateMessage = "";
          }
        }

        if (value.toLowerCase() === "customer") {
          userType = "D";
        } else {
          userType = "C";
        }

        filterDepts = this.state.changeForm.departments.filter(
          (departments) => {
            return (
              departments.customerType === userType ||
              departments.customerType === "DC"
            );
          }
        );
      }
    }
    if (name === "userName") {
      if (value === "") {
        validationErrors.userNameVaidateMessage =
          "Please enter the Client Name.";
        document.getElementById("lstUsers").style.display = "none";
      } else {
        validationErrors.userNameVaidateMessage = "";
        this.onkeyPress(value);
      }
    }
    if (name === "drpdwnDepartments") {
      if (value === "") {
        validationErrors.departmentValidateMessage =
          "Please select the Departments.";
      } else {
        validationErrors.departmentValidateMessage = "";
      }
    }
    this.setState({
      validationMessages: validationErrors,
    });

    this.setState({
      changeForm: {
        ...this.state.changeForm,
        [name]: value,
        filteredDepartments: filterDepts,
      },
    });
  }
  async onkeyPress(value) {
    if (value !== "") {
      document.getElementById("loader").classList.remove("hide");
      let { response, err } = await customerSupplierService.getContacts(
        value,
        this.state.clientId
      );
      document.getElementById("loader").classList.add("hide");
      if (err) {
      } else if (response && response.err) {
      } else {
        document.getElementById("lstUsers").style.display = "block";
        this.setState({
          changeForm: {
            ...this.state.changeForm,
            users: response.data.data,
          },
          isNoRecordsFound: response.data.data.length === 0 ? true : false,
        });
      }
    }
  }

  onClickLi(e) {
    let userId = e.target.getAttribute("data-userid");
    let email = e.target.getAttribute("data-email");
    let userType = e.target.getAttribute("data-usertype");
    let userName = e.target.getAttribute("data-username");
    document.getElementById("lstUsers").style.display = "none";
    document.getElementById("lblUserType").innerText = userType;
    this.setState({
      changeForm: {
        ...this.state.changeForm,
        userName: userName,
        userEmail: email,
        userType: userType,
        userId: userId,
      },
    });
  }
  populateDepartments() {}
  async componentDidMount() {
    this.props.context.actions.setDepartments();
    let departments = this.props.context.state.departments;
    this.setState({
      changeForm: {
        ...this.state.changeForm,
        departments: departments,
      },
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.context.state.departments !== prevProps.context.state.departments) {
      this.setState({
        changeForm: {
          ...this.state.changeForm,
          departments: this.props.context.state.departments,
        },
      });
    }
  }

  render() {
    const authorizationResult = super.render();
    if (authorizationResult) {
      return authorizationResult;
    }

    let users = this.state.changeForm.users;
    let error = "bg-warning text-dark";
    let success = "bg-success text-white";
    let lis = "";
    if (users !== undefined) {
      if (users.length > 0) {
        lis = users.map((element, index) => {
          return (
            <li
              key={index}
              style={{ cursor: "pointer" }}
              className="list-group-item"
              data-email={element.email}
              data-usertype={element.userType}
              data-username={element.companyName}
              data-userid={element.userId}
              onClick={this.onClickLi}
            >
              {element.companyName}
            </li>
          );
        });
      }
    }

    let clientTypes = [{ name: "Customer" }, { name: "Supplier" }];
    let { userName } = this.state.changeForm;
    let {
      userNameVaidateMessage,
      departmentValidateMessage,
      changeToValidateMessage,
    } = this.state.validationMessages;
    return (
      <div className="app flex-row align-items-center">
        <div className="container change-customer-type">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="card mx-4">
                <div className="card-body p-4">
                  <h3 className="text-center page-title">CHANGE CLIENT TYPE</h3>
                  <hr />
                  <div className="row">
                    <div className="col-sm-12">
                      <p
                        style={{ textAlign: "center" }}
                        className={this.state.isError ? error : success}
                      >
                        {this.state.message}
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label className="lblUserName" htmlFor="userName">
                          Client Name
                          <span className="mandatory">*</span>
                          &nbsp; <span className="error-msg"> </span>
                          &nbsp;{" "}
                          <span id="loader" className="loading hide"></span>
                          &nbsp;{" "}
                          <span className="error-msg">
                            {userNameVaidateMessage}
                          </span>
                        </label>

                        <input
                          required
                          type="text"
                          className="form-control"
                          autoComplete="off"
                          name="userName"
                          id="userName"
                          value={userName || ""}
                          onChange={this.onChange}
                        />

                        <div id="lstUsers">
                          {this.state.changeForm.users ? (
                            <ul
                              style={{ overflowY: "auto" }}
                              className="list-group"
                              id="userList"
                            >
                              {this.state.changeForm.users.length > 0 ? (
                                lis
                              ) : this.state.isNoRecordsFound ? (
                                <li className="list-group-item active">
                                  no records found
                                </li>
                              ) : (
                                ""
                              )}
                            </ul>
                          ) : (
                            <div>&nbsp;</div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>Client Type</label>
                        <span> : </span>
                        <label
                          style={{ fontWeight: "bold" }}
                          id="lblUserType"
                        ></label>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <DropDown
                        label="New Client Type "
                        name="drpDwnChangeTo"
                        required={true}
                        error={changeToValidateMessage}
                        onChange={this.onChange}
                        defaultItem={defaultListItem}
                        list={clientTypes}
                        valProp="name"
                        textProp="name"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      {this.state.changeForm.filteredDepartments.length > 0 ? (
                        <DropDown
                          label="Departments"
                          name="drpdwnDepartments"
                          required={true}
                          error={departmentValidateMessage}
                          onChange={this.onChange}
                          defaultItem={defaultListItem}
                          list={this.state.changeForm.filteredDepartments}
                          valProp="deptId"
                          textProp="deptName"
                        />
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <input
                        type="button"
                        className="btn btn-block btn-info rounded-0 "
                        id="btnSubmit"
                        value="SUBMIT"
                        onClick={this.onSubmit}
                      />
                      <span>&nbsp;</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
